export default {
  "/bill/payment": [
    {
      path: false,
      name: "应付账款列表",
    },
  ],
  "/bill/detail": [
    {
      path: "/bill/payment",
      name: "应付账款列表",
    },
    {
      path: false,
      name: "应收账款详情",
    },
  ],
  "/bill/repay": [
    {
      path: "/bill/payment",
      name: "应付账款列表",
    },
    {
      path: false,
      name: "还款明细",
    },
  ],
  "/bill/record": [
    {
      path: "/bill/payment",
      name: "应付账款列表",
    },
    {
      path: false,
      name: "流转记录",
    },
  ],
  "/bill/recordDetail": [
    {
      path: "/bill/payment",
      name: "应付账款列表",
    },
    {
      path: false,
      name: "流转记录",
    },
    {
      path: false,
      name: "详情",
    },
  ],
  "/bill/repayDetail": [
    {
      path: "/bill/payment",
      name: "应付账款列表",
    },
    {
      path: false,
      name: "还款明细",
    },
    {
      path: false,
      name: "详情",
    },
  ],
  
  "/certificate/list": [
    {
      path: false,
      name: "电子债权凭证",
    },
    {
      path: "/certificate/list",
      name: "持有凭证",
    },
  ],
  "/certificate/detail": [
    {
      path: "/certificate/list",
      name: "电子债权凭证",
    },
    {
      path: false,
      name: "详情",
    },
  ],
  "/certificate/record": [
    {
      path: false,
      name: "电子债权凭证",
    },
    {
      path: "/certificate/record",
      name: "流转记录",
    },
  ],
  // certificate/record
  "/bill/pay": [
    {
      path: false,
      name: "付款列表",
    },
  ],
  "/enterprise/list": [
    {
      path: false,
      name: "上游企业",
    },
  ],
  "/financing/index": [
    {
      path: false,
      name: "融资申请",
    },
  ],
  "/financingOrder/list": [
    {
      path: false,
      name: "融资订单",
    },
  ],
  "/checkout/list": [
    {
      path: false,
      name: "应收账款列表",
    },
  ],
  "/enterprise/detail": [
    {
      path: "/enterprise/list",
      name: "上游企业",
    },
    {
      path: false,
      name: "上游企业详情",
    },
  ],
  "/finance/list": [
    {
      path: false,
      name: "已签约金融机构",
    },
  ],
  "/finance/detail": [
    {
      path: "/finance/list",
      name: "已签约金融机构",
    },
    {
      path: false,
      name: "金融机构详情",
    },
  ],
  "/user/account/info": [
    {
      path: false,
      name: "用户中心",
    },
    {
      path: false,
      name: "账户信息",
    },
  ],
  "/user/company/info": [
    {
      path: false,
      name: "用户中心",
    },
    {
      path: false,
      name: "企业信息",
    },
  ],
  "/enterpriseCorrelation/list": [
    {
      path: false,
      name: "用户中心",
    },
    {
      path: false,
      name: "关联核心企业",
    },
  ],
  "/user/company/edit": [
    {
      path: "/user/company/info",
      name: "企业信息",
    },
    {
      path: false,
      name: "企业信息修改",
    },
  ],
};
